const hasStorage = () => {
  try {
    return typeof window !== "undefined" && window.localStorage !== undefined;
  } catch {
    return false;
  }
};

export const readStorage = (key, fallback = null) => {
  if (!hasStorage()) return fallback;
  try {
    const value = window.localStorage.getItem(key);
    return value == null ? fallback : value;
  } catch {
    return fallback;
  }
};

export const writeStorage = (key, value) => {
  if (!hasStorage()) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* quota exceeded, storage disabled, etc. */
  }
};

export const removeStorage = (key) => {
  if (!hasStorage()) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* storage disabled */
  }
};

export const readJsonStorage = (key, fallback = null) => {
  const raw = readStorage(key, null);
  if (raw == null) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeJsonStorage = (key, value) => {
  try {
    writeStorage(key, JSON.stringify(value));
  } catch {
    /* circular refs etc. */
  }
};
